import { flexPoolService } from 'ogp/services';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { CreateFlexPoolPayload } from '../../../../../../services/flex-pool-service.types';

type FlexPoolMutationOptions = UseMutationOptions<unknown, unknown, CreateFlexPoolPayload>;

const useCreateFlexPool = (options?: FlexPoolMutationOptions) => {
  const mutationFn = async (payload: CreateFlexPoolPayload) =>
    await flexPoolService.createFlexPool(payload);

  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  const mutationOptions: FlexPoolMutationOptions = {
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.flexPools());
      queryClient.invalidateQueries(QUERY_KEYS.workTemplates());
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  };

  return useMutation(mutationFn, mutationOptions);
};

export { useCreateFlexPool };
